import { isTextFile } from './fileTypeHelpers';
import { looksLikeImage } from './looksLikeImage';
import { generateTextThumbnail } from './textThumbnail';

export async function generateFilePreview(fileObject: File): Promise<string> {
	if (looksLikeImage(fileObject)) {
		try {
			return URL.createObjectURL(fileObject);
		} catch (error) {
			const errorMessage =
				error instanceof Error
					? error.message
					: typeof error === 'string'
						? error
						: 'Failed to create blob URL for image file';
			throw new Error(`Failed to create blob URL for image: ${errorMessage}`);
		}
	} else if (isTextFile(fileObject.type, fileObject.name)) {
		return await generateTextThumbnail(fileObject);
	}
	throw new Error(`Unsupported file type: ${fileObject.type}`);
}
